import type { RouteObject } from 'react-router-dom';
import { Login, MFAVerification, MFASetup, MFARecoveryCodes, Logout, ForgotPassword, ResetPassword } from '@/pages/auth';

export const mfaRoutes: RouteObject[] = [
    {
        path: 'mfa',
        children: [
            {
                path: 'verify',
                element: <MFAVerification />,
            },
            {
                path: 'setup',
                element: <MFASetup />,
            },
            {
                path: 'recovery-codes',
                element: <MFARecoveryCodes />,
            },
        ],
    },
];

export const loginRoute: RouteObject[] = [
    {
        path: 'login',
        element: <Login />,
    },
];

export const logoutRoute: RouteObject[] = [
    {
        path: 'logout',
        element: <Logout />,
    },
];

export const forgotPasswordRoute: RouteObject[] = [
    {
        path: 'password/forgot',
        element: <ForgotPassword />,
    },
];

export const resetPasswordRoute: RouteObject[] = [
    {
        path: 'password/reset',
        element: <ResetPassword />,
    },
];
